import { render, staticRenderFns } from "./ID.vue?vue&type=template&id=a9c04928&"
import script from "./ID.vue?vue&type=script&lang=js&"
export * from "./ID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports